import serviceBase from '@/services/serviceBase'

class gradeService extends serviceBase {
    constructor() {
        super(process.env.VUE_APP_API_ENDPOINT)
    }

    getGrades(idProduto, tipoGrade) {
        return this.get(`${this.getSubdominio()}/grade?idProduto=${idProduto}&tipoGrade=${tipoGrade}`)
    }

    getGradesAtivas(idProduto, idGrade, tipoGrade) {
        tipoGrade = tipoGrade == 1 ? 2 : 1;
        
        return this.get(`${this.getSubdominio()}/grade/ativas?idProduto=${idProduto}&idGrade=${idGrade}&tipoGrade=${tipoGrade}`)
    }
}

export default new gradeService()